<template>
  <el-footer height="90px">
    <div class="timeline"
      @mousedown="handleDragStart"
      @mousemove="handleDrag"
      @mouseup="handleDragEnd"
    >
      <div class="timeline__legend" v-if="hasRiderInfo">
        <div class="legend__item" v-for="(item, key) in riderStatusMap" :key="key">
          <div class="legend__color" :style="{background: item.color}"></div>
          <div>{{item.name}}</div>
        </div>
      </div>
      <div class="timeline__status">
        <div
          v-for="(item, index) in statusView"
          :key="index"
          :style="{background: item.color, width: item.width + '%'}"
        ></div>
      </div>
      <div class="timeline__ordernum">
        <div
          v-for="(item, index) in orderNumView"
          :style="{ width: item.width + '%', height: item.height + 'px' }"
          :key="index"
        ></div>
      </div>
      <div class="timeline__frame" ref="frame">
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">05:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">06:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">07:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">08:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">09:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">10:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">11:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">12:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">13:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">14:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">15:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">16:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">17:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">18:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">19:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">20:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">21:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">22:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">23:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">00:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">01:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">02:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">03:00</div>
        </div>
        <div class="timeunit">
          <div class="block">
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
            <div class="hight_div">
              <div class="low_div"></div>
              <div class="low_div"></div>
              <div class="low_div"></div>
            </div>
          </div>
          <div class="scale">04:00</div>
          <div class="scale-end">04:59</div>
        </div>
      </div>
      <div class="mock"
        @mouseover="handleMouseOver"
        @mouseout="handleMouseOut"
        @mousemove="handleMouseMove"
        :style="{display: draging ? 'none' : 'block'}"
      >
      </div>
      <div class="data-detail" ref="detail" v-show="hasRiderInfo && showDetail">
        <div class="time-detail-panel">
          <div>时间：{{hoverDetail.time}}</div>
          <div>状态：{{riderStatusMap[hoverDetail.riderStatus + ''] ? riderStatusMap[hoverDetail.riderStatus + ''].name : ''}}</div>
          <div>未完成单量：{{hoverDetail.orderNum}}</div>
        </div>
      </div>
      <div class="pointer"
        ref="pointer"
      >
        <div class="numTime">
          <input type="text"
           @input="hourInput" v-model="numHour" placeholder="时" @keyup.enter="submitTime" />:<input
            type="text" @input="minInput" v-model="numMin" placeholder="分" @keyup.enter="submitTime"/>:<input
           type="text" @input="secInput" v-model="numSec" placeholder="秒" @keyup.enter="submitTime"/>
        </div>
      </div>
    </div>
  </el-footer>
</template>

<script>
import { mapState } from 'vuex';
import { RIDER_STATUS_MAP } from 'common/constant';
import { getDayTimeByTimestamp, throttle } from 'common/utils';
import blankImgSrc from '../../../static/images/blank.png';

const ORIGIN_START = 42.5;
const POINTER_FIXED_LENGTH = 5;
const DAY_SECOND = 86400;
let DAY_TIME = 0;
let BASE_TIME = 0;

export default {
  name: 'TimeLine',
  data() {
    const blankImg = new Image();
    blankImg.src = blankImgSrc;
    return {
      riderStatusMap: RIDER_STATUS_MAP,
      showDetail: false,
      draging: false,
      hoverDetail: {
        time: '',
        orderNum: 0,
        riderStatus: '',
      },
      screenWidth: document.body.clientWidth,
      numHour: '00',
      numMin: '00',
      numSec: '00',
      numTime: 0,
      blankImg,
    };
  },
  props: {
    time: {
      type: Number,
    },
    riderStatus: {
      type: Object, // { 1519869655: 1 }
    },
    riderOrderCount: {
      type: Object,
    },
  },
  watch: {
    time(value) {
      this.$refs.pointer.style.left = `${this.computePositionByTime(value)}px`;
      this.setNumTime(this.time);
    },
    screenWidth() {
      this.resizeThrottle = this.resizeThrottle || throttle((time) => {
        this.fullLength = this.$refs.frame.offsetWidth;
        this.$refs.pointer.style.left = `${this.computePositionByTime(time)}px`;
      }, 500);
      this.resizeThrottle(this.time);
    },
    baseTimeTemp(value) {
      BASE_TIME = String(value).slice(0, length - 3) - 0;
    },
  },
  computed: {
    ...mapState({
      // 输入框输入时的基准时间点00点
      baseTimeTemp: ({ aside }) => aside.baseTimeTemp,
    }),
    hasRiderInfo() {
      return this.riderStatus && this.riderOrderCount;
    },
    maxTime() {
      // return this.time - (this.time + 28800) % 86400 + 86400;
      return this.time - (this.time + 10800) % 86400 + 86400 - 1;
    },
    minTime() {
      return this.maxTime + 1 - 86400;
    },
    fullSecond() {
      // return (this.time + 28800) % DAY_SECOND;
      return (this.time + 10800) % DAY_SECOND;
    },
    orderNumView() {
      if (this.riderOrderCount) {
        const countTimeArray = Object.keys(this.riderOrderCount);
        countTimeArray.push(this.maxTime);
        const countValueArray = Object.values(this.riderOrderCount);
        // eslint-disable-next-line
        const perHeight = 30 / Math.max.apply(Math, countValueArray);

        return countTimeArray.map((item, index) => {
          if (index < countTimeArray.length - 1) {
            const nextTime = countTimeArray[index + 1];
            return {
              width: (nextTime - item) / DAY_SECOND * 100,
              height: perHeight * this.riderOrderCount[item],
            };
          }
          return {
            width: 0,
            height: 0,
          };
        });
      }
      return [];
    },
    statusView() {
      if (this.riderStatus) {
        const riderStatusTimeArray = Object.keys(this.riderStatus);
        this.riderStatus[this.maxTime] = this.riderStatus[riderStatusTimeArray[length]];
        const defaultColor = '#CCC';
        riderStatusTimeArray.push(this.maxTime);
        return riderStatusTimeArray.map((item, index) => {
          if (index < riderStatusTimeArray.length) {
            const nextTime = riderStatusTimeArray[index + 1];
            return {
              // eslint-disable-next-line
              width: (nextTime - item)/DAY_SECOND * 100,
              color: RIDER_STATUS_MAP[this.riderStatus[item]] ?
                RIDER_STATUS_MAP[this.riderStatus[item]].color : defaultColor,
            };
          }
          return {
            width: 0,
            color: defaultColor,
          };
        });
      }
      return [];
    },
  },
  methods: {
    // 回车修改浮标位置
    submitTime() {
      if (this.numHour - 0 > 4 && this.numHour - 0 < 24) {
        this.numTime = (BASE_TIME - 0) + this.numHour * 3600 + this.numMin * 60 + (this.numSec - 0);
      } else if (this.numHour - 0 >= 0 && this.numHour - 0 < 5) {
        this.numTime = (BASE_TIME - 0) + this.numHour * 3600 +
        86400 + this.numMin * 60 + (this.numSec - 0);
      }
      this.$refs.pointer.style.left = `${this.computePositionByTime(this.numTime)}px`;
      this.$emit('time-change', this.numTime);
    },
    // 时输入时的input事件
    hourInput(e) {
      const val = e.target.value;
      if (/^[0-9]+$/.test(val)) {
        if (val - 0 > 23 || val - 0 < 0) {
          this.numHour = '00';
          return;
        }
        if (val >= 0 && val < 10) {
          this.numHour = `0${val - 0}`;
          return;
        }
        this.numHour = val - 0;
      } else {
        this.numHour = '05';
      }
    },
    // 分输入时的input事件
    minInput(e) {
      const val = e.target.value;
      if (/^[0-9]+$/.test(val)) {
        if (val - 0 > 59 || val - 0 < 0) {
          this.numMin = '00';
          return;
        }
        if (val >= 0 && val < 10) {
          this.numMin = `0${val - 0}`;
          return;
        }
        this.numMin = val - 0;
      } else {
        this.numMin = '00';
      }
    },
    // 秒输入时的input事件
    secInput(e) {
      const val = e.target.value;
      if (/^[0-9]+$/.test(val)) {
        if (val - 0 > 59 || val - 0 < 0) {
          this.numSec = '00';
          return;
        }
        if (val >= 0 && val < 10) {
          this.numSec = `0${val - 0}`;
          return;
        }
        this.numSec = val - 0;
      } else {
        this.numSec = '00';
      }
    },
    setNumTime(time) {
      let hour;
      let minute;
      let sec;
      if (new Date(time * 1000).getHours() < 10) {
        hour = `0${new Date(time * 1000).getHours()}`;
      } else {
        hour = new Date(time * 1000).getHours();
      }
      if (new Date(time * 1000).getMinutes() < 10) {
        minute = `0${new Date(time * 1000).getMinutes()}`;
      } else {
        minute = new Date(time * 1000).getMinutes();
      }
      if (new Date(time * 1000).getSeconds() < 10) {
        sec = `0${new Date(time * 1000).getSeconds()}`;
      } else {
        sec = new Date(time * 1000).getSeconds();
      }
      // this.numTime = `${hour}:${minute}`;
      this.numHour = hour;
      this.numMin = minute;
      this.numSec = sec;
    },
    handleDragStart() {
      // event.dataTransfer.dropEffect = 'move';
      // event.dataTransfer.setData('infoName', '');
      // event.dataTransfer.setDragImage(this.blankImg, 0, 0);
      this.draging = true;
    },
    handleDrag(event) {
      if (this.draging === true) {
        this.updatePointerLeft(event.movementX);
      }
    },
    handleDragEnd() {
      // this.updatePointerLeft(event.offsetX);
      this.draging = false;
    },
    updatePointerLeft(plus) {
      const pointer = this.$refs.pointer;
      const originLeft = pointer.style.left;
      let left = originLeft ? parseInt(originLeft, 10) + plus : plus;
      const mostRight = this.computePositionByTime(this.maxTime); // 右边界
      const mostLeft = this.computePositionByTime(this.minTime); // 左边界

      if (left > this.fullLength + ORIGIN_START || left > mostRight) {
        left = mostRight;
        this.updateTime = this.maxTime;
      } else if (left < ORIGIN_START || left < mostLeft) {
        left = mostLeft;
        this.updateTime = this.minTime;
      } else {
        this.updateTime = this.computeTimeByPosition(left - ORIGIN_START + POINTER_FIXED_LENGTH);
      }
      pointer.style.left = `${left}px`;
      this.setNumTime(this.updateTime);
      if (this.updateTime && this.updateTime <= this.maxTime) {
        this.$emit('time-change', this.updateTime);
      }
    },
    computeTimeByPosition(value) {
      if (!value || value < 0) return;
      // eslint-disable-next-line
      const fullSecond = Math.floor(value / this.fullLength * DAY_SECOND);
      // eslint-disable-next-line
      return this.time - this.fullSecond + fullSecond;
    },
    // 计算今天00:00点时间戳
    computeDayTime(value) {
      DAY_TIME = value - ((value + 28800) % 86400);
    },
    /**
     * 通过秒级时间戳，计算指针位置
     */
    computePositionByTime(value) {
      this.computeDayTime(value);
      if (!value || value < 0 || !this.$refs.frame) return ORIGIN_START;
      // 加8小时是因为北京时间+8小时
      // const fullSecond = (value + 28800) % DAY_SECOND;
      const fullSecond = (value + 10800) % DAY_SECOND;
      const offsetX = fullSecond * this.fullLength / DAY_SECOND;
      const left = offsetX;
      return left + ORIGIN_START - POINTER_FIXED_LENGTH;
    },
    handleMouseOver() {
      if (this.draging) {
        return;
      }
      this.showDetail = true;
    },
    handleMouseOut() {
      this.showDetail = false;
      this.$refs.detail.style.left = 0;
    },
    handleMouseMove(event) {
      if (this.draging || !this.hasRiderInfo) {
        return;
      }
      this.mouseMoveThrottle = this.mouseMoveThrottle || throttle((e) => {
        let left = e.offsetX;
        if (left > this.fullLength) {
          left = this.fullLength;
        }
        this.$refs.detail.style.left = `${left}px`;
        const timestamp = this.computeTimeByPosition(left);
        if (timestamp) {
          this.hoverDetail.time = getDayTimeByTimestamp(timestamp);
          this.hoverDetail.orderNum = this.getOrderNumByTime(timestamp);
          this.hoverDetail.riderStatus = this.getRiderStatusByTime(timestamp);
        }
      }, 100);
      this.mouseMoveThrottle(event);
    },
    getOrderNumByTime(time) {
      const timesArray = Object.keys(this.riderOrderCount);
      const index = timesArray.findIndex(item => (time <= parseInt(item, 10)));
      let closeTime;
      if (index > -1) {
        closeTime = timesArray[index - 1];
      } else {
        closeTime = timesArray[timesArray.length - 1];
      }
      return this.riderOrderCount[closeTime];
    },
    getRiderStatusByTime(time) {
      const timesArray = Object.keys(this.riderStatus);
      const index = timesArray.findIndex(item => (time <= parseInt(item, 10)));
      let closeTime;
      if (index) {
        closeTime = timesArray[index - 1];
      } else {
        closeTime = timesArray[timesArray.length - 1];
      }
      return this.riderStatus[closeTime];
    },
  },
  mounted() {
    this.fullLength = this.$refs.frame.offsetWidth;
    this.$refs.pointer.style.left = `${this.computePositionByTime(this.time)}px`;
    // 设置坐标轴上的数字时间
    this.setNumTime(this.time);
    this.computeDayTime(this.time);
    BASE_TIME = DAY_TIME;
    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };
  },
};
</script>

<style lang="less">
.el-footer {
  background: #fff;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  // left: 56px;
  z-index: 1000;
  width: 100%;
  padding: 0;
  padding-top: 8px;
  padding-left: 56px;
  display: flex;
  align-items: center;
}
.timeline {
  width: 100%;
  padding: 10px 40px;
  padding-top: 0;
  box-sizing: border-box;
  position: relative;
  user-select:none;
}
.timeline__legend {
  font-size: 12px;
  padding: 8px;
  padding-right: 0;
  background-color: #fff;
  width: 210px;
  display: flex;
  flex-wrap: wrap;
  color: #666;
  position: absolute;
  right: 14px;
  top: -65px;

  .legend__item {
    width: 70px;
    display: flex;
    align-items: center;
    height: 20px;;
  }
  .legend__color {
    width: 20px;
    height: 10px;
    background: #ff9900;
    margin-right: 6px;
    border: 1px solid #eee;
  }
}
.timeline__status {
  height: 40px;
  display: flex;
  padding-left: 1px;
  .last-item {
    width: 1px;
    flex-grow: 1;
  }
}
.timeline__ordernum {
  // margin-top: -30px;
  margin-top: -21px;
  height: 20px;
  display: flex;
  align-items: flex-end;
  div {
    background: rgba(255, 0, 0, .1);
    border-top: 1px solid #FF0000;
  }
}
.timeline__frame {
  margin-top: -29px;
  border-bottom: none;
  border-right: none;
  display: flex;
  border-left: 1px solid #ccc;
}
.timeunit {
  height: 50px;
  border-right: 1px solid #ccc;
  width: 50px;
  flex-grow: 1;
  flex-shrink: 1;
  // background-color: #fff;
  border-top: none;
  .block {
    box-sizing: border-box;
    padding-top:10px;
    height: 30px;
    border-bottom: 1px solid #ccc;
    display: flex;
    .hight_div{
      flex: 1;
      height: 20px;
      border-right:1px solid #ccc;
      display: flex;
      box-sizing: border-box;
      padding-top: 10px;
      .low_div{
        flex: 1;
        height: 10px;
        border-right:1px solid #ccc;
      }
      .low_div:last-child{
        border-right: none;
      }
    }
    .hight_div:last-child{
        border-right: none;
    }
  }
  .scale {
    padding-top: 10px;
    font-size: 12px;
    margin-left: -15px;
  }
  .scale-end {
    font-size: 12px;
    margin-top: -14px;
    text-align: right;
    margin-right: -15px;
  }
}
.pointer {
  width: 1px;
  height: 40px;
  position: absolute;
  top: 2px;
  z-index: 1001;
  cursor: move;

  .numTime{
    box-sizing: border-box;
    line-height: 28px;
    background-color: #fff;
    width: 80px;
    height: 28px;
    border-radius: 100px;
    box-shadow: 0 2px 10px 0 rgba(33, 43, 54, 0.28);
    overflow: hidden;
    position: absolute;
    top: 40px;
    left:-38px;
    text-align: center;
    color: #4A90E2;
    input{
      width: 20px;
      outline: none;
      color: #4A90E2;
      font-size: 16px;
      text-align: center;
      border: none;
      padding: 0;
      height: 100%;
      line-height: 100%;
    }
    input::-webkit-input-placeholder {
      color: #4A90E2;
      opacity: 0.6;
    }
  }
}
.pointer::after{
  content: '';
  position: absolute;
  top:0;
  left:-8px;
  background: url('../../../static/images/pointer.png');
  background-repeat: no-repeat;
  background-size: 22px 40px;
  width: 22px;
  height: 40px;
  z-index: 1002;
}
.mock {
  height: 70px;
  margin-top: -50px;
  z-index: 1000;
  position: absolute;
  width: 100%;
}
.data-detail {
  font-size: 12px;
  margin-left: 40px;
  border-left: 1px solid #000;
  position: absolute;
  left: 0px;
  height: 40px;
  margin-top: -60px;
  transition: left .5s ease;

  .time-detail-panel {
    background: rgba(0, 0, 0, .4);
    margin-top: -40px;
    margin-left: 5px;
    padding: 8px 10px;
    border-radius: 3px;
    color: #FFF;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/TimeLine/index.vue